<mat-card-content>
    <p class="title"><strong>Indicizza singolo documento</strong></p>
        <div class="info-banner">
            <mat-icon>info</mat-icon>
            <span class="info-text">
            Attenzione: non abusare della funzionalità, usare una tantum. Si consiglia invece di usare la funzionalità di crawling.
            </span>
        </div>
</mat-card-content>

    <mat-card-content class="my-3">
        <form [formGroup]="formData" #formDirective="ngForm" (ngSubmit)="indicizzaDocumenti(formDirective)">
           <div class="url-input">
                <mat-form-field appearance="fill" class="url-field">
                        <mat-label>URL Documento</mat-label>
                        <input matInput formControlName="documentUrl" autocomplete="off" spellcheck="false" inputmode="url" />

                        <mat-error *ngIf="formData.get('documentUrl')?.hasError('required')">
                            Il campo è obbligatorio
                        </mat-error>
                        <mat-error *ngIf="formData.get('documentUrl')?.hasError('pattern')">
                            URL non valido (deve iniziare con http:// o https://)
                        </mat-error>
                    </mat-form-field>
                    <div class="action-div">
                        <button mat-raised-button class="btn-primary btn-play" type="submit" [disabled]="formData.invalid || isLoading">
                            <mat-icon>play_arrow</mat-icon>
                            Avvia
                        </button>
                        <mat-progress-spinner *ngIf="isLoading" diameter="20" mode="indeterminate"></mat-progress-spinner>
                    </div>
                    
           </div>
                    

        </form>
    </mat-card-content>
